import { defineMessages } from 'react-intl';

export default defineMessages({
  ACHIEVEMENTS_LABEL: {
    defaultMessage: 'Badges',
  },

  STREAKS_LABEL: {
    defaultMessage: 'Flammes',
  },
} as const);
